/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/NewRelation/Add/Content/Details/LastName",
  isInvalid,
  onChange
  
}) {
let newRelationPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'new_relation',
path: 'person.last_name',
})
let newRelationPersonLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_relation',
path: 'person.last_name',
validate: fromValidate.name,
required: true,
})
let newRelationPersonLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'new_relation',
path: 'person.last_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="new_relation.person.last_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!newRelationPersonLastNameIsValidData}
 value={newRelationPersonLastNameValueData}
 onChange={newRelationPersonLastNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}